import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../../../app/hooks/useAxios';
import queryClient from '../../../../../app/utils/queryClient';

const useAuthOktaFactorSmsMutation = () => {
	const { post, remove } = useAxios();

	const setFactor = (profile: { phoneNumber: string }) => {
		return post(`/users/me/factors`, {
			factorType: 'sms',
			provider: 'OKTA',
			profile,
		});
	};

	const activateFactor = (passCode: string) => {
		return post(`/users/me/factors/sms/activate`, {
			passCode,
		});
	};

	const resendFactor = () => {
		return post(`/users/me/factors/sms/resend`);
	};

	const deleteFactor = () => {
		return remove(`/users/me/factors/sms/remove`);
	};

	return {
		mutateSetFactor: useMutation(setFactor, {
			onSuccess: () => {
				queryClient.invalidateQueries(['authOktaUserFactorsCatalog']);
			},
		}),
		mutateActivateFactor: useMutation(activateFactor, {
			onSuccess: () => {
				queryClient.invalidateQueries(['authOktaUserFactorsCatalog']);
			},
		}),
		mutateResendFactor: useMutation(resendFactor, {
			onSuccess: () => {
				queryClient.invalidateQueries(['authOktaUserFactorsCatalog']);
			},
		}),
		mutateDeleteFactor: useMutation(deleteFactor, {
			onSuccess: () => {
				queryClient.invalidateQueries(['authOktaUserFactorsCatalog']);
			},
		}),
	};
};

export default useAuthOktaFactorSmsMutation;
